<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
  		<div class="container">
			<h1>Contact us</h1>
		</div>
	</section>
  </div>
  
  <section class="section">
	<div class="container">	
		
		<div class="columns">
			<div class="column content main is-two-thirds">

				<h2 class="title">Get in touch</h2>
				<p v-html="contact.text" />


	            <div class="columns">
	                
	                <div class="column">
	                   <div class="card match-height">
	                      <div class="card-content match-content-height">
	                        <div class="content">
	                            <p class="title">
	                                Contact info
	                            </p>
	                            <p>Email us: <a href="mailto:secretary@combinedactors.org">secretary@combinedactors.org</a></p>
	                        </div>
	                      </div>
	                    </div>
	                </div>

	                <div class="column">
	                    <div class="card match-height">
	                      <div class="card-content match-content-height">
	                		<div class="content">
	                            <p class="title">
	                                Social media
	                            </p>
	                            <div class="description">
									<ul>
										<li class="facebook"><a href="https://www.facebook.com/camactors/" target="_blank">Facebook</a></li>
										<li class="twitter"><a href="https://twitter.com/camactors" target="_blank">Twitter</a></li>
										<li class="youtube"><a href="https://www.youtube.com/results?search_query=%22combined+actors+of+cambridge%22" target="_blank">Our videos on Youtube</a></li>
									</ul>
								</div>

	                        </div>
	                      </div>
	                    </div>
	                </div>

	            </div>
			        

	        </div>
	        <div class="column">

				<aside class="sidebar" v-if="plays.length > 0" >
		            <h1 class="header">
		                Want to audition?
		            </h1>
		            <SidebarCards :items="plays" />
		        </aside>
	        
	        </div>
        </div>
       

	</div>
  </section>
</div>
</template>


<script>
import SidebarCards from './cards/SidebarCards';
import Api from '@/config/Api'

export default {
	components: {
        SidebarCards
    },
    data() {
        return {
            contact: {},
            plays: [],
        }
    },
    /* computed: {
        country() {
            return this.$store.getters.getCountry
        }
    }, */
    created() {
        Api().get(`/api/contactus`).then(response => {
	      this.contact = response.data;
	      this.$store.commit('setContentLoaded', true); // then footer will be displayed
	    });
	    Api().get(`/api/plays/opentoauditions`).then(response => {
            this.plays = response.data.plays;
            console.log("opentoauditions created", this.plays);
        });
    },
    metaInfo: {
      title: "Contact us",
      // titleTemplate: null // override the parent template and just use the above title only
    }
}
</script>

<style scoped>

.card .description ul {
   padding: 0;
   margin: 0;
   list-style-type: none; 
   font-size: 16px; 
   line-height:20px;
}
.card .description li.facebook:before {
   content: url('/images/icons/socialicon_facebook.png');
   vertical-align: -50%;
   padding: 0 12px 0 0;
}
.card .description li.twitter:before {
   content: url('/images/icons/socialicon_twitter.png');
   vertical-align: -50%;
   padding: 0 12px 0 0;
}
.card .description li.youtube:before {
   content: url('/images/icons/socialicon_youtube.png');
   vertical-align: -50%;
   padding: 0 12px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue